import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import Space from "./space"
import Text from "./text"
import Divider from "./divider"
import Link from "./link"
import ButtonFill from "./button-fill"
import { onClickArticleContentAd } from "../utils/hook"
import { getHost } from "../utils/url"

type Props = {
  article: {
    slug: string | null
  }
  content: any
}

const ArticleAd: React.FC<Props> = ({ article, content }) => {
  if (content!.contentAd) {
    const ad = content!.contentAd
    return (<>
      <div>
        <Space sizeY="6" lgSizeY="8" />
        <div className="bg-white rounded-2xl shadow p-5">
          <div
            className="flex flex-col items-center space-y-3 lg:flex-row lg:space-x-4 cursor-pointer"
          >
            <div className="w-full aspect-w-16 aspect-h-9 lg:aspect-w-none lg:aspect-h-none">
              <GatsbyImage
                className="absolute-important"
                objectFit="contain"
                image={ad.images[0]!.gatsbyImageData!}
                alt={ad.images[0]!.title!}
              />
            </div>
            <div className="w-full">
              <Text
                fontSize="base"
                lgFontSize="lg"
                fontBold={true}
              >
                {ad.title!}
              </Text>
              <Space sizeY="2" lgSizeY="4" />
              <Text fontSize="xs" lgFontSize="sm">
                {getHost(ad.links[0]!.url!)}
              </Text>
            </div>
          </div>
          <Space sizeY="4" lgSizeY="6" />
          <div className="flex flex-col lg:flex-row items-center gap-3">
            {ad.links!.map((link: any) => {
              return (
                <Link
                  key={link!.url!}
                  href={link!.url!}
                  external={true}
                  sponsored={true}
                  classes="w-full"
                >
                  <ButtonFill
                    classes="w-full py-3"
                    color="blue-800"
                    onClick={() => {
                      onClickArticleContentAd({
                        id: article.slug!,
                        adTitle: ad.title!,
                        adUrl: link!.url!,
                      })
                    }}
                  >
                    {link!.title!}
                  </ButtonFill>
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </>)
  }
  //  Deprecated component
  return (<>
    {content!.contentAdImage && (
      <div>
        <Space sizeY="6" lgSizeY="8" />
        <div className="bg-white rounded-2xl shadow p-5">
          <div
            className="flex flex-col items-center space-y-3 lg:flex-row lg:space-x-4 cursor-pointer"
            onClick={() => {
              window.open(
                content!.contentAdUrl!,
                "_blank"
              )
              onClickArticleContentAd({
                id: article.slug!,
                adTitle: content!.contentAdTitle!,
                adUrl: content!.contentAdUrl!,
              })
            }}
          >
            <div className="w-full aspect-w-16 aspect-h-9 lg:aspect-w-none lg:aspect-h-none">
              <GatsbyImage
                className="absolute-important"
                objectFit="contain"
                image={
                  content!.contentAdImage!
                    .gatsbyImageData!
                }
                alt={content!.contentAdImage!.title!}
              />
            </div>
            <div className="w-full">
              <Text
                fontSize="base"
                lgFontSize="lg"
                fontBold={true}
              >
                {content!.contentAdTitle}
              </Text>
              <Space sizeY="2" lgSizeY="4" />
              <Text fontSize="xs" lgFontSize="sm">
                {getHost(content!.contentAdUrl!)}
              </Text>
            </div>
          </div>
          <Space sizeY="4" lgSizeY="6" />
          <Link
            href={content!.contentAdUrl!}
            external={true}
            sponsored={true}
          >
            <ButtonFill
              classes="w-full py-4"
              color="blue-800"
              onClick={() => {
                onClickArticleContentAd({
                  id: article.slug!,
                  adTitle: content!.contentAdTitle!,
                  adUrl: content!.contentAdUrl!,
                })
              }}
            >
              {content!.contentAdButton ||
                "Amazonで購入する"}
            </ButtonFill>
          </Link>
        </div>
      </div>
    )}
  </>)
}

export default ArticleAd
